import logo from './logo.svg';
import './App.css';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
    <div>
      <PrivacyPolicy/>
 
    </div>
  );
}

export default App;
